const ThreeCubes = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="82" height="62" fill="none" viewBox="0 0 82 62">
      <g clipPath="url(#ThreeCubesA)">
        <path fill="url(#ThreeCubesB)" d="m82 9.68-18.556 9.68L44.89 9.68 63.444 0 82 9.68Z"/>
        <path fill="url(#ThreeCubesC)" d="m82 29.037-18.556 9.68V19.361L82 9.68v19.356Z"/>
        <path fill="url(#ThreeCubesD)" d="m63.444 38.717-18.555-9.68V9.68l18.555 9.68v19.357Z"/>
        <path fill="#3F75EA" d="m63.687 19.585-.243 19.132V19.361l.242.224Z"/>
        <path fill="url(#ThreeCubesE)" d="m82 9.68-18.556 9.68.242.225L82 9.68Z"/>
        <path fill="#3F75EA" d="M63.444 19.36 44.89 9.68l18.21 9.905.345 19.132V19.361Z" opacity=".76"/>
        <path fill="url(#ThreeCubesF)" d="m44.89 9.68 18.209 9.905.345 19.132-18.555-9.676V9.681Z" opacity=".44"/>
      </g>
      <g clipPath="url(#ThreeCubesG)">
        <path fill="url(#ThreeCubesH)" d="m59.134 20.645-18.555 9.68-18.556-9.68 18.556-9.68 18.555 9.68Z"/>
        <path fill="url(#ThreeCubesI)" d="m59.134 40.001-18.555 9.68V30.325l18.555-9.68V40Z"/>
        <path fill="url(#ThreeCubesJ)" d="m40.579 49.681-18.556-9.68V20.645l18.556 9.68v19.357Z"/>
        <path fill="#04BB8B" d="M40.82 30.55 40.58 49.68V30.325l.242.224Z"/>
        <path fill="#04BB8B" d="m59.134 20.645-18.555 9.68.242.224 18.313-9.904Z"/>
        <path fill="#04BB8B" d="m40.579 30.325-18.556-9.68 18.21 9.904.346 19.133V30.325Z" opacity=".75"/>
      </g>
      <g clipPath="url(#ThreeCubesK)">
        <path fill="url(#ThreeCubesL)" d="m36.267 31.82-18.133 9.89L0 31.82l18.134-9.891 18.133 9.89Z"/>
        <path fill="url(#ThreeCubesM)" d="m36.267 51.597-18.133 9.89V41.712l18.133-9.891v19.777Z"/>
        <path fill="url(#ThreeCubesN)" d="M18.134 61.488 0 51.597V31.82l18.134 9.89v19.778Z"/>
        <path fill="#3F75EA" d="m18.37 41.94-.236 19.548V41.71l.236.229Z"/>
        <path fill="url(#ThreeCubesO)" d="m36.267 31.82-18.133 9.89.236.23 17.897-10.12Z"/>
        <path fill="#3F75EA" d="M18.134 41.71 0 31.82l17.796 10.12.338 19.548V41.71Z" opacity=".76"/>
        <path fill="url(#ThreeCubesP)" d="m0 31.82 17.796 10.12.338 19.548L0 51.602V31.82Z" opacity=".44"/>
      </g>
      <defs>
        <linearGradient id="ThreeCubesB" x1="44.889" x2="38.578" y1="29.704" y2="4.856" gradientUnits="userSpaceOnUse">
          <stop offset=".016" stopColor="#1B0E72"/>
          <stop offset=".98" stopColor="#707DDF" stopOpacity=".6"/>
        </linearGradient>
        <linearGradient id="ThreeCubesC" x1="83.237" x2="73.372" y1="27.885" y2="7.259" gradientUnits="userSpaceOnUse">
          <stop offset=".016" stopColor="#1B0E72"/>
          <stop offset=".98" stopColor="#707DDF"/>
        </linearGradient>
        <linearGradient id="ThreeCubesD" x1="60.02" x2="30.59" y1="19.171" y2="46.32" gradientUnits="userSpaceOnUse">
          <stop offset=".082" stopColor="#2E074F"/>
          <stop offset=".232" stopColor="#280648"/>
          <stop offset=".447" stopColor="#190536"/>
          <stop offset=".661" stopColor="#03031C"/>
        </linearGradient>
        <linearGradient id="ThreeCubesE" x1="65.709" x2="81.978" y1="18.323" y2="8.949" gradientUnits="userSpaceOnUse">
          <stop offset=".146" stopColor="#3F75EA"/>
          <stop offset=".967" stopColor="#6B2F91" stopOpacity="0"/>
        </linearGradient>
        <linearGradient id="ThreeCubesF" x1="28.189" x2="65.966" y1="13.336" y2="22.229" gradientUnits="userSpaceOnUse">
          <stop offset=".031" stopColor="#6E7DE3"/>
          <stop offset="1" stopColor="#0015A0"/>
        </linearGradient>
        <linearGradient id="ThreeCubesH" x1="14.609" x2="50.499" y1="6.33" y2="27.572" gradientUnits="userSpaceOnUse">
          <stop offset=".058" stopColor="#2E3386"/>
          <stop offset=".231" stopColor="#2E3986"/>
          <stop offset=".457" stopColor="#2C4986"/>
          <stop offset=".71" stopColor="#2A6485"/>
          <stop offset=".904" stopColor="#287D85"/>
        </linearGradient>
        <linearGradient id="ThreeCubesI" x1="36.59" x2="59.658" y1="55.04" y2="17.931" gradientUnits="userSpaceOnUse">
          <stop offset=".269" stopColor="#005B71"/>
          <stop offset=".338" stopColor="#006774"/>
          <stop offset=".715" stopColor="#03A385"/>
          <stop offset=".894" stopColor="#04BB8B"/>
        </linearGradient>
        <linearGradient id="ThreeCubesJ" x1="22.624" x2="41.542" y1="40.146" y2="28.483" gradientUnits="userSpaceOnUse">
          <stop stopColor="#015576"/>
          <stop offset=".957" stopColor="#113B62"/>
        </linearGradient>
        <linearGradient id="ThreeCubesL" x1="-4.489" x2="31.377" y1="18.782" y2="39.087" gradientUnits="userSpaceOnUse">
          <stop offset=".323" stopColor="#2E074F"/>
          <stop offset=".441" stopColor="#330A55"/>
          <stop offset=".593" stopColor="#421465"/>
          <stop offset=".764" stopColor="#5B2480"/>
          <stop offset=".856" stopColor="#6B2F91"/>
        </linearGradient>
        <linearGradient id="ThreeCubesM" x1="19.511" x2="38.045" y1="58.699" y2="30.181" gradientUnits="userSpaceOnUse">
          <stop offset=".016" stopColor="#253E81"/>
          <stop offset=".434" stopColor="#6B2F91"/>
          <stop offset=".511" stopColor="#713090"/>
          <stop offset=".615" stopColor="#83328C"/>
          <stop offset=".734" stopColor="#9F3587"/>
          <stop offset=".865" stopColor="#C73A7F"/>
          <stop offset=".98" stopColor="#F03F77"/>
        </linearGradient>
        <linearGradient id="ThreeCubesN" x1="14.787" x2="-15.146" y1="41.516" y2="67.928" gradientUnits="userSpaceOnUse">
          <stop offset=".082" stopColor="#2E074F"/>
          <stop offset=".232" stopColor="#280648"/>
          <stop offset=".447" stopColor="#190536"/>
          <stop offset=".661" stopColor="#03031C"/>
        </linearGradient>
        <linearGradient id="ThreeCubesO" x1="20.346" x2="36.59" y1="40.65" y2="31.698" gradientUnits="userSpaceOnUse">
          <stop offset=".146" stopColor="#3F75EA"/>
          <stop offset=".967" stopColor="#6B2F91" stopOpacity="0"/>
        </linearGradient>
        <linearGradient id="ThreeCubesP" x1="-6.834" x2="16.718" y1="57.45" y2="41.742" gradientUnits="userSpaceOnUse">
          <stop offset=".274" stopColor="#AD3784"/>
          <stop offset=".42" stopColor="#952E79" stopOpacity=".778"/>
          <stop offset=".727" stopColor="#56175D" stopOpacity=".312"/>
          <stop offset=".933" stopColor="#290749" stopOpacity="0"/>
        </linearGradient>
        <clipPath id="ThreeCubesA">
          <path fill="#fff" d="M0 0h37.111v38.797H0z" transform="translate(44.89)"/>
        </clipPath>
        <clipPath id="ThreeCubesG">
          <path fill="#fff" d="M0 0h37.111v38.797H0z" transform="translate(22.023 10.964)"/>
        </clipPath>
        <clipPath id="ThreeCubesK">
          <path fill="#fff" d="M0 0h36.267v39.641H0z" transform="translate(0 21.929)"/>
        </clipPath>
      </defs>
    </svg>
  );
}

export default ThreeCubes;
